import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseRequestLinesSearch = () => {
  const warehouseRequestLinesSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/request-lines/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { warehouseRequestLinesSearch }
}

export default InteractorWarehouseRequestLinesSearch
